import React from 'react';

const PriceDisplay = ({ price, originalPrice, className = '', size = 'md' }) => {
  const hasDiscount = originalPrice && originalPrice > price;
  const discountPct = hasDiscount ? Math.round(((originalPrice - price) / originalPrice) * 100) : 0;

  const sizeClasses = {
    sm: { price: 'text-sm', original: 'text-xs', badge: 'text-[9px] px-1 py-0' },
    md: { price: 'text-lg', original: 'text-sm', badge: 'text-[10px] px-1.5 py-0.5' },
    lg: { price: 'text-3xl', original: 'text-base', badge: 'text-xs px-2 py-0.5' },
  }[size] || { price: 'text-lg', original: 'text-sm', badge: 'text-[10px] px-1.5 py-0.5' };

  return (
    <div className={`flex items-center gap-2 flex-wrap ${className}`} data-testid="price-display">
      <span className={`text-primary font-bold ${sizeClasses.price}`}>{'\u20B9'}{price}</span>
      {hasDiscount && (
        <>
          <span className={`text-muted-foreground line-through ${sizeClasses.original}`}>{'\u20B9'}{originalPrice}</span>
          <span className={`bg-accent/10 text-accent font-semibold rounded-full ${sizeClasses.badge}`}>{discountPct}% off</span>
        </>
      )}
    </div>
  );
};

export default PriceDisplay;
